import { createFileRoute } from '@tanstack/react-router';
import { apiClient } from '@/lib/api/client';
import { getPath } from '@/lib/api/path';
import { InvitationErrorPage } from './-components/InvitationErrorPage';
import type { InvitationDetail } from './-type';
import { loadInvitationDetail } from './-utils/loadInvitationDetail';
export const Route = createFileRoute('/auth/invitation/$invitationCode/')({
  errorComponent: InvitationErrorPage,
  loader: async ({
    params
  }) => {
    const invitation = await loadInvitationDetail(() => apiClient.GET(getPath('/v2/invitations/{invitationCode}'), {
      params: {
        path: {
          invitationCode: params.invitationCode
        }
      }
    }));
    return {
      invitation: {
        email: invitation.email,
        givenName: invitation.givenName,
        familyName: invitation.familyName,
        middleName: invitation.middleName,
        targetEmails: invitation.targetEmails ?? [],
        loginRequirements: invitation.loginRequirements
      } satisfies InvitationDetail
    };
  }
});